import React, { useState, useEffect, useRef } from 'react';
import './Header.css';
import { FaBars, FaUserCircle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import axios from "axios";


const Header = ({ toggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // const [permissions, setPermissions] = useState({});


  const userId = localStorage.getItem("user_id");
  const userName = JSON.parse(localStorage.getItem('user_name'));

  const handleLogOut = () => {
    // console.log("test");
    /* */
    axios.post(`${API_BASE_URL}logout.php`,
      {
        user_id: userId
      }
    )
      .then((response) => {
        if (response.data.head.code === 200) {
          localStorage.removeItem("user_id"); // Remove userId from localStorage
          navigate("/login");
          // setUserList(response.data.body);
          // setFilteredOrders(response.data.body);
          // window.location.reload();
          // navigate('/home');
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setUserList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setUserList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

  }

  // Close dropdown on outside click
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setDropdownOpen(false);
  //     }
  //   };
  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => document.removeEventListener('mousedown', handleClickOutside);
  // }, []);

  // useEffect(() => {
  //   let userId = localStorage.getItem("user_id");
  //   console.log("from header", userId);
  //   if (!userId) {
  //     console.error("No user ID found. Please log in again.");
  //     return;
  //   }

  //   userId = userId.replace(/^"|"$/g, ''); // Remove extra double quotes if they exist

  //   const fetchPermissions = async () => {
  //     try {
  //       console.log("Sending API request with user_id:", userId);

  //       const response = await axios.post(`${API_BASE_URL}employee_login_previllage.php`,
  //         { user_id: userId }, // Ensure correct format
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             "Accept": "application/json",
  //           },
  //         }
  //       );

  //       console.log("API Fixed Response:", response.data);

  //       if (response.data.head.code === 200 && response.data.body.length > 0) {
  //         setPermissions(response.data.body[0]);
  //       } else {
  //         alert("Error : Previlage Error");
  //       }
  //     } catch (error) {
  //       alert("API Error: Unable to fetch permissions.");
  //       console.error("API Error:", error);
  //     }
  //   };

  //   fetchPermissions();
  // }, []);

  return (
    <header className="header">
      <div className="left-section">
        <FaBars className="menu-icon" onClick={toggleSidebar} />
      </div>

      <div className="right-section" ref={dropdownRef}>
        <div className="user-box" onClick={() => setDropdownOpen(!dropdownOpen)}>
          <span className="username p-2">{userName}</span>
          <FaUserCircle className="user-icon" />

        </div>

        {dropdownOpen && (
          <div className="dropdown-menu">
            <Link onClick={() => handleLogOut()} className="dropdown-item">Logout</Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
